import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/specifications/:id");
export const getIndexPath = returnPath("/specifications");
